import { createContext } from 'react'

// TRP-4453: true when the card currently rendering ChatHotelCarouselPrice had its offer built
// from svc-trip's offer-detail DTO (the carousel's pre-edit hydration path) rather than from
// the client-side NLS re-query (post-edit).
//
// The predicate is about the offer's *provenance*, not only its price, and it now gates two
// decisions in ChatHotelCarouselPrice: skip the live price re-fetch (the DTO price is already
// correct for the requested dates), and take the "Stays from N nights" length from the
// property's region-marketed LOS (the adapter builds one synthetic package and no options
// list, so the package-match rule that decides this on the client-fetched path is
// unanswerable). The name is narrower than the fact; widen it to something like
// CarouselOfferSourceContext if a third use appears.
//
// Default false — every existing consumer of ChatHotelCarouselPrice that never wraps it in a
// Provider gets today's live-refetch behavior and today's caption rule, unchanged.
//
// Bedbank cards never reach this context at all: OfferCardMapper only forwards PricingComponent
// to LEOfferCard, so a bedbank card never mounts ChatHotelCarouselPrice and stays on the
// client-fetched rate (useBedbankRates / fetchAccumulatedRatesForBedbankOffer). This is a
// deliberate scope decision, not a gap — bedbank has no composition layer equivalent to
// TRP-4410's, and TRP-4391 measured bedbank prices against checkout as agreeing.
const CarouselPricingSourceContext = createContext(false)

export default CarouselPricingSourceContext
